module.exports = __webpack_public_path__ + "static/media/bg_left.f70884f6.png";